<template>
  <div class="containerFull" style="min-height: 600px">
    <div class="p-grid">
      <div class="p-col-12">
        <h2 class="p-mt-6 titulo-admin">{{ $t("messages.quotation") }}</h2>
        <h5 style="border-bottom: 1px solid #cfcfcf" class="p-pb-5">
          {{ $t("messages.quotationDescription") }}
        </h5>
      </div>
      <div class="p-col-12 p-md-12 p-pl-5 p-pr-5">
        <h5>{{ $t("messages.patientData") }}</h5>
        <div class="p-grid p-mt-4" style="flex-direction: column;">
          <div class="p-field p-col-12 p-md-4">
            <span class="p-float-label">
              <Dropdown style="width:100%" v-model="item.tipoIdentificacion" optionValue="value"
                :options="tiposDeIdentificacion" optionLabel="name" autofocus />
              <label for="tipoIdentificacion">{{ $t("messages.identificationType") }}</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <span class="p-float-label">
              <InputText id="identificacion" type="text" v-model.trim="item.identificacion" autofocus
                style="width:100%" />
              <label for="identificacion">{{ $t("messages.identificationNumber") }}</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <span class="p-float-label">
              <InputText id="nombres" v-model.trim="item.nombres" autofocus style="width:100%" />
              <label for="nombres">{{ $t("messages.name") }}</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <span class="p-float-label">
              <InputText id="apellidos" v-model.trim="item.apellidos" autofocus style="width:100%" />
              <label for="apellidos">{{ $t("messages.lastName") }}</label>
            </span>
          </div>
          <!-- <div class="p-field p-col-12 p-md-2">
            <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="saveItem" :disabled="loading" name="guardar" />
          </div>   -->
        </div>

        <!-- <div v-for="(paciente, index) in pacientes" :key="index" class="itemSelected">
          <span>{{ paciente.identificacion }}</span>
          <span>{{ paciente.nombres }}</span>
          <span>{{ paciente.apellidos }}</span>
          <span>{{ paciente.fechaNacimiento }}</span>
          <span>{{ paciente.nacionalidad }}</span>
          <span @click="eliminarPaciente(index)">Eliminar</span>
        </div> -->
        <h5>{{ $t("messages.anesthesia") }}</h5>
        <RadioButton id="general" name="general" value="general" v-model="anestesia" class="p-mr-2" />
        <label for="general" class="p-mr-5">{{ $t("messages.general") }}</label>
        <RadioButton id="local" name="local" value="local" v-model="anestesia" class="p-mr-2" />
        <label for="local">{{ $t("messages.local") }}</label>
        <h5>{{ $t("messages.surgeryToBePerformed") }}</h5>
        <div class="p-fluid p-mb-3">
          <AutoComplete v-model="cirugiaSeleccionada" :suggestions="cirugiasFiltradas" @complete="buscarCirugias($event)"
            :dropdown="true" field="nombre" @item-select="itemSelected($event)"
            :disabled="this.cirugiaSeleccionadas.length >= limiteSeleccion" class="autocompleteCirugias" />
        </div>
        <div v-for="(cirugia, index) in cirugiaSeleccionadas" :key="index" class="itemSelected">
          <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text"
            @click="eliminarItem(cirugia.id)" />
          <span>{{ cirugia.nombre }}</span>
        </div>
        <h5>{{ $t("messages.duration") }}</h5>
        <InputText type="number" v-model.number="duracion" :min="1" class="inputDuracion" />
        <!-- <h5>Póliza</h5>
        <div class="p-fluid p-mb-3">
          <Dropdown
            id="poliza"
            v-model="polizaSeleccionada"
            :options="polizasNombreFormateado"
            placeholder="Seleccione una póliza"
            autofocus
            optionLabel="nombre"
            showClear
            class="autocompleteCirugias"
          />
        </div> -->
        <div class="p-field-checkbox p-mt-4">
          <Checkbox id="aceptoPoliticas" v-model="aceptoPoliticas" :binary="true" />
          <label for="aceptoPoliticas" class="p-ml-2">
            <router-link to="/pipma" target="_blank">{{ $t('messages.acceptPipma') }}</router-link>
          </label>
        </div>
        <p class="p-mt-3">
          <Button :label="$t('messages.calculate')" @click="confirmCreacionCotizacion" name="calcular"
            :disabled="tarifasFull.length == 0 || cirugiaSeleccionadas.length == 0 || duracion < 1 || !aceptoPoliticas" />
        </p>
        <hr class="p-mb-6 p-mt-6" v-if="valor > 0" />
        <div v-if="valor > 0" class="p-mb-6">
          <BotonDescargaCotizacion :id="id" v-if="id" />
          <h4>{{ $t("messages.surgeries").toUpperCase() }}</h4>
          <ul>
            <li v-for="(cirugia, index) in cirugiaSeleccionadas" :key="index" style="font-size: 19px">
              {{ cirugia.nombre }}
            </li>
          </ul>
          <h4>{{ $t("messages.patientData").toUpperCase() }}</h4>
          <ul>
            <li>
              <strong>{{ $t("messages.identificationType") }}: </strong>{{ item.tipoIdentificacion }}
            </li>
            <li>
              <strong>{{ $t("messages.identificationNumber") }}: </strong>{{ item.identificacion }}
            </li>
            <li>
              <strong>{{ $t("messages.name") }}: </strong>{{ item.nombres }}
            </li>
            <li>
              <strong>{{ $t("messages.lastName") }}: </strong>{{ item.apellidos }}
            </li>
          </ul>
          <h4 v-if="polizaSeleccionada">{{ $t("resumenCotizacion.policeValue").toUpperCase() }}</h4>
          <span class="valor" v-if="polizaSeleccionada">{{ formatNumber(polizaSeleccionada.valor) }}$</span>
          <h4>{{ $t("resumenCotizacion.valueTotal").toUpperCase() }}</h4>
          <span class="valor">{{ formatNumber(redondearAlCienMasProximo(precioTotal())) }}$</span>
          <!-- <h4>{{ $t("resumenCotizacion.valueWithDiscount").toUpperCase() }}</h4>
          <span class="valor">{{ formatNumber(precioConDescuento()) }}$</span> -->
          <p class="p-mt-6" style="font-size: 20px" v-if="anestesia == 'general'">
            <strong>{{ $t("resumenCotizacion.valueAnesthesiageneral") }}</strong>
          </p>
          <p class="p-mt-6" style="font-size: 20px" v-else>
            <strong>{{ $t("resumenCotizacion.valueAnesthesialocal") }}</strong>
          </p>
          <p class="p-mt-6" style="font-size: 20px">
            <strong>{{ $t("resumenCotizacion.vigenciaTarifa").toUpperCase() }}</strong>
          </p>
        </div>
        <hr class="p-mb-6" v-if="valor > 0" />
        <div v-if="valor > 0">
          <h2 style="font-weight: bold">{{ $t("resumenCotizacion.timeToQuote").toUpperCase() }}</h2>
          <h4 class="p-mt-6" style="font-weight: bold">{{ $t("resumenCotizacion.start").toUpperCase() }}</h4>
          <ul v-if="anestesia == 'general'">
            <li>
              {{ $t("resumenCotizacion.startGeneral.line1") }}
            </li>
            <li>
              {{ $t("resumenCotizacion.startGeneral.line2") }}
            </li>
            <li>
              {{ $t("resumenCotizacion.startGeneral.line3") }}
            </li>
          </ul>
          <ul v-else>
            <li>
              {{ $t("resumenCotizacion.startLocal.line1") }}
            </li>
          </ul>
          <p v-if="anestesia == 'general'">
            <strong>{{ $t("messages.note").toUpperCase() }}: </strong>{{ $t("resumenCotizacion.noteGeneral.line1") }}
          </p>
          <p v-else>
            <strong>{{ $t("messages.note").toUpperCase() }}: </strong>{{ $t("resumenCotizacion.noteLocal.line1") }}
            <br />
            <br />
            <strong>{{ $t("resumenCotizacion.noteLocal.line2") }}</strong>
          </p>
          <h4 class="p-mt-6" style="font-weight: bold">{{ $t("resumenCotizacion.end").toUpperCase() }}</h4>
          <ul>
            <li>{{ $t("resumenCotizacion.endLine1") }}</li>
          </ul>
          <p>
            <strong>{{ $t("messages.note") }}: </strong>{{ $t("resumenCotizacion.endNote") }}</p>
        </div>
        <article class="incluyentes p-mb-6 p-mt-6" v-if="valor > 0">
          <p>
            <strong>{{ $t("resumenCotizacion.noteTarifaLine1") }}</strong>{{ $t("resumenCotizacion.noteTarifaLine2") }}</p>
          <h4 class="p-mt-6">
            <strong>{{ $t("resumenCotizacion.includeTitle") }}:</strong>
          </h4>
          <ul>
            <li>{{ $t("resumenCotizacion.includeList.line1") }}</li>
            <li v-if="anestesia == 'general'">
              {{ $t("resumenCotizacion.includeList.line2") }}
            </li>
            <li>
              {{ $t("resumenCotizacion.includeList.line3") }}
            </li>
            <li>{{ $t("resumenCotizacion.includeList.line4") }}</li>
            <li>
              {{ $t("resumenCotizacion.includeList.line5") }}
            </li>
            <li>{{ $t("resumenCotizacion.includeList.line6") }}</li>
          </ul>
          <p>
            <strong>{{ $t("messages.note") }}: </strong><span v-html="$t('resumenCotizacion.noteInclude')"></span>
          </p>
          <h4 class="p-mt-6" v-if="anestesia == 'general'">
            <strong>{{ $t("resumenCotizacion.notIncludeTitle") }}</strong>
          </h4>
          <div v-if="anestesia == 'general'">
            <div>
              <ul>
                <li>{{ $t("resumenCotizacion.notInclude.line1") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line2") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line3") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line4") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line5") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line6") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line7") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line8") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line9") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line10") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line11") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line12") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line13") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line14") }}</li>
              </ul>
            </div>
            <div>
              <ul>
                <li>{{ $t("resumenCotizacion.notInclude.line15") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line16") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line17") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line18") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line19") }}</li>
                <li>{{ $t("resumenCotizacion.notInclude.line20") }}</li>
              </ul>
            </div>
          </div>
          <h4 class="p-mt-6"><strong>{{ $t("resumenCotizacion.keepInMind").toUpperCase() }}</strong></h4>
          <ul>
            <li>
              <p class="p-mb-3">
                {{ $t("resumenCotizacion.keepInMindList.line1") }}
              </p>
              <ul>
                <li>{{ $t("resumenCotizacion.keepInMindList.line2") }}</li>
                <li>{{ $t("resumenCotizacion.keepInMindList.line3") }}</li>
                <li>{{ $t("resumenCotizacion.keepInMindList.line4") }}</li>
                <li>{{ $t("resumenCotizacion.keepInMindList.line5") }}</li>
                <li>{{ $t("resumenCotizacion.keepInMindList.line6") }}</li>
              </ul>
            </li>
            <li>{{ $t("resumenCotizacion.keepInMindList.line7") }}</li>
          </ul>
        </article>
      </div>
    </div>
    <Dialog :visible="crearCotizacionDialog" :style="{ width: '450px' }" :header="$t('messages.confirmation')"
      :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span v-if="item">{{ $t("messages.confirmQuotation") }}</span>
      </div>
      <template #footer>
        <Button :label="$t('messages.no')" icon="pi pi-times" class="p-button-text" @click="crearCotizacionDialog = false"
          name="cancelar" />
        <Button :label="$t('messages.yes')" icon="pi pi-check" class="p-button-text" @click="calcularCosto" name="aceptar" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import CirugiasService from "../service/cirugias.service";
import TarifasService from "../service/tarifas.service";
import PolizasService from "../service/polizas.service";
import CotizacionesService from "../service/cotizaciones.service";
import BotonDescargaCotizacion from "./boton_descarga_cotizacion.vue";
export default {
  metaInfo: {
    title: 'Cotización de servicios',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Cotización de servicios',
        content: 'Sitio para cotizar servicios de cirugía, con la posibilidad de descargar la cotización en PDF'
      },
    ],
  },
  components: {
    BotonDescargaCotizacion
  },
  data() {
    return {
      /* anestesia = 0 general */
      /* anestesia = 1 local */
      cirugiasService: null,
      tarifasService: null,
      polizasService: null,
      cotizacionesService: null,
      cirugias: [],
      cirugiaSeleccionadas: [],
      cirugiasFiltradasFull: [],
      duracion: 0,
      valor: 0,
      anestesia: "general",
      tarifasFull: [],
      cirugiasFiltradas: [],
      cirugiaSeleccionada: null,
      limiteSeleccion: 4,
      /* configurar banderazos */
      banderazos: [
        {
          riesgo: 2,
          minutos: 30,
          valor: 1367520,
          tipo_anestesia: 0,
        },
        {
          riesgo: 3,
          minutos: 30,
          valor: 1664551,
          tipo_anestesia: 0,
        },
        {
          riesgo: 4,
          minutos: 30,
          valor: 1925726,
          tipo_anestesia: 0,
        },
        {
          riesgo: 5,
          minutos: 30,
          valor: 2239135,
          tipo_anestesia: 0,
        },
      ],
      descuento: 0.95,
      downloading: false,
      polizas: [],
      polizaSeleccionada: null,
      pacientes: [],
      item: {
        tipoIdentificacion: null,
        identificacion: null,
        nombres: null,
        apellidos: null,
        observaciones: ""
      },
      aceptoPoliticas: false,
      submitted: false,
      loading: false,
      crearCotizacionDialog: false,
      maxDate: new Date(),
      id: null      
    };
  },
  created() {
    this.cirugiasService = new CirugiasService();
    this.tarifasService = new TarifasService();
    this.polizasService = new PolizasService();
    this.cotizacionesService = new CotizacionesService();
  },
  mounted() {
    this.recuperarCirugias();
    this.recuperarTarifas();
    this.recuperarPolizas();
  },
  methods: {
    eliminarPaciente(index) {
      this.pacientes.splice(index, 1);
    },
    saveItem() {
      this.submitted = true;
      if (!this.item.tipoIdentificacion || !this.item.identificacion || !this.item.nombres || !this.item.apellidos) {
        this.submitted = false;
        return;
      }
      this.pacientes.push(this.item);
      this.item = {
        tipoIdentificacion: null,
        identificacion: null,
        nombres: null,
        apellidos: null,
        observaciones: ""
      };
      this.submitted = false;
    },
    recuperarTarifas() {
      this.tarifasService
        .allTarifasUsers()
        .then((result) => {
          if (result.data.data) {
            this.tarifasFull = [...result.data.data];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    recuperarPolizas() {
      this.polizasService
        .allPolizas()
        .then((result) => {
          if (result.data.data) {
            this.polizas = [...result.data.data];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    recuperarCirugias() {
      this.cirugiasService
        .allCirugias()
        .then((result) => {
          if (result.data.data) {
            this.cirugias = [...result.data.data];
            this.filtrarCirugias();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    buscarCirugias(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.cirugiasFiltradas = [...this.cirugiasFiltradasFull];
        } else {
          this.cirugiasFiltradas = this.cirugiasFiltradasFull.filter(
            (cirugia) => {
              return (
                cirugia.nombre
                  .toLowerCase()
                  .indexOf(event.query.toLowerCase()) != -1
              );
            }
          );
        }
      }, 250);
    },
    filtrarCirugias() {
      const anestesiaValue = this.anestesia == "general" ? 0 : 1;
      const indexSelected = this.cirugiaSeleccionadas.map((item) => {
        return item.id;
      });
      this.cirugiasFiltradasFull = this.cirugias.filter((item) => {
        return (
          item.anestesia == anestesiaValue &&
          indexSelected.indexOf(item.id) == -1
        );
      });
    },
    formatNumber(numero) {
      return new Intl.NumberFormat("de-DE").format(numero);
    },
    calcularCosto() {
      //let costoPorMinuto = 0;
      if (this.cirugiaSeleccionadas.length == 0) {
        this.$toast.add({
          severity: "warn",
          summary: this.$t("messages.error"),
          detail: this.$t("messages.mustSelectASurgery"),
          life: 3000,
        });
        this.valor = 0;
        return false;
      }
      if (this.duracion == "" || this.duracion < 1) {
        this.$toast.add({
          severity: "warn",
          summary: this.$t("messages.error"),
          detail: this.$t("messages.timeMoreThanZero"),
          life: 3000,
        });
        this.valor = 0;
        return false;
      }
      let valores = [];
      for (let index = 0; index < this.cirugiaSeleccionadas.length; index++) {
        valores.push(
          this.calcularCostoDeCirugia(this.cirugiaSeleccionadas[index])
        );
      }
      //conseguir el precio mayor
      this.valor = Math.max(...valores);
      this.crearCotizacion();
    },
    redondearAlMilMasProximo(numero) {
      let redondeadoAlMilMasCercano = 0;
      if (numero <= 1000) {
        redondeadoAlMilMasCercano = 1000;
      } else {
        redondeadoAlMilMasCercano = Math.floor(numero);
        while (redondeadoAlMilMasCercano % 1000 != 0) {
          redondeadoAlMilMasCercano++;
        }
      }
      return redondeadoAlMilMasCercano;
    },
    redondearAlCienMasProximo(numero) {
      return Math.ceil(numero / 100) * 100;
    },
    itemSelected(evento) {
      this.cirugiaSeleccionadas.push(evento.value);
      this.cirugiaSeleccionada = null;
      this.filtrarCirugias();
    },
    eliminarItem(idCirugia) {
      this.cirugiaSeleccionadas = this.cirugiaSeleccionadas.filter((item) => {
        return item.id != idCirugia;
      });
      this.filtrarCirugias();
    },
    calcularCostoDeCirugia(dataCirugia) {
      let tarifas = this.tarifasFull.filter((item) => {
        return item.riesgo == dataCirugia.riesgo;
      });

      if (tarifas.length > 0) {
        tarifas.sort(function (a, b) {
          if (a.limite > b.limite) {
            return 1;
          }
          if (a.limite < b.limite) {
            return -1;
          }
          return 0;
        });
        tarifas.push({
          costo_por_minuto: tarifas[tarifas.length - 1].costo_por_minuto,
          id: 9999999,
          limite: tarifas[tarifas.length - 1].limite,
          riesgo: tarifas[tarifas.length - 1].riesgo,
          status: 1,
        });
      }
      let sumaCosto = 0;
      for (let index = 0; index < tarifas.length; index++) {
        const tarifa = tarifas[index];
        const rango =
          index == 0
            ? [0, tarifa.limite]
            : index + 1 == tarifas.length
              ? [tarifa.limite, 99999999999]
              : [tarifas[index - 1].limite, tarifa.limite];

        if (this.duracion >= rango[0]) {
          if (this.duracion > rango[0] && index + 1 == tarifas.length) {
            //por encima del ultimo rango
            sumaCosto += (this.duracion - rango[0]) * tarifa.costo_por_minuto;
          } else if (
            this.duracion > rango[0] &&
            this.duracion <= rango[1] &&
            index == 0
          ) {
            //dentro del primer rango
            sumaCosto += this.duracion * tarifa.costo_por_minuto;
          } else if (this.duracion == rango[1] && index + 1 != tarifas.length) {
            //igual al final de un rango pero no esta ni en el primero ni al final
            sumaCosto += (this.duracion - rango[0]) * tarifa.costo_por_minuto;
          } else if (this.duracion > rango[1] && index + 1 != tarifas.length) {
            //la duracion es mayor a el mayor de un rango
            sumaCosto += (rango[1] - rango[0]) * tarifa.costo_por_minuto;
          } else {
            //la duracion esta dentro de un rango
            sumaCosto += (this.duracion - rango[0]) * tarifa.costo_por_minuto;
          }
        }
      }
      const banderazo = this.banderazos.filter((item) => {
        return (
          item.riesgo == dataCirugia.riesgo &&
          item.tipo_anestesia == dataCirugia.anestesia
        );
      });
      if (banderazo.length > 0 && this.duracion < banderazo[0].minutos) {
        sumaCosto = banderazo[0].valor;
      }
      return sumaCosto;
    },
    /* descargarpdf() {
      this.downloading = true;
      let dataPdf = {
        cirugias: this.cirugiaSeleccionadas
          .map((item) => {
            return this.primeraMayuscula(item.nombre);
          })
          .join("%%%%"),
        precio: this.formatNumber(this.redondearAlMilMasProximo(this.precioTotal())),
        precio_descuento: this.formatNumber(this.redondearAlMilMasProximo(this.precioConDescuento())),
        tiempo: this.duracion,
        fecha_hora: this.primeraMayuscula(
          this.$moment().format("dddd, MMMM DD [de] YYYY [a las] HH:mm")
        ),
        tipo_anestesia: this.anestesia == "general" ? 0 : 1,
      };
      if (this.polizaSeleccionada) {
        dataPdf.poliza_nombre = this.polizaSeleccionada.nombre;
      }
      this.tarifasService
        .downloadCotizacion(dataPdf)
        .then((response) => {
          this.downloading = false;
          const nameCotizacion =
            "cot" + this.$moment().format("DDMMYYYYHHmmss");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${nameCotizacion}.pdf`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          this.downloading = false;
          this.$toast.add({
            severity: "error",
            summary: "Error en descarga",
            detail: "Error al tratar de descargar cotización",
            life: 3000,
          });
        });
    }, */
    descargarpdfconid(id) {
      this.downloading = true;
      this.cotizacionesService
        .downloadCotizacionConId(id,this.$i18n.locale)
        .then((response) => {
          const contentDisposition = response.headers["content-disposition"];
          let fileName = contentDisposition ? contentDisposition.split(";")[1].split("=")[1] : "descarga.pdf";
          fileName = fileName.replace(/"/g, "");
          this.downloading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          console.log(e);
          this.downloading = false;
          this.$toast.add({
            severity: "error",
            summary: this.$t("messages.error"),
            detail: this.$t("messages.errorDownloadQuotation"),
            life: 3000,
          });
        });
    },
    primeraMayuscula(cadena) {
      cadena = cadena.toLowerCase();
      return cadena.replace(/\b[a-z]/g, (c) => c.toUpperCase());
    },
    precioTotal() {
      let poliza = 0;
      if (this.polizaSeleccionada) {
        poliza = this.polizaSeleccionada.valor;
      }
      return this.valor + poliza;
    },
    precioConDescuento() {
      let poliza = 0;
      if (this.polizaSeleccionada) {
        poliza = this.polizaSeleccionada.valor;
      }
      return (this.redondearAlCienMasProximo(this.precioTotal()) * this.descuento) + poliza;
    },
    confirmCreacionCotizacion() {
      this.crearCotizacionDialog = true;
    },
    crearCotizacion() {
      const pacientes = [];

      if (!this.allItemsAreNull) {
        let itemFormated = { ...this.item };
        itemFormated.nombres = (itemFormated.nombres && itemFormated.nombres.trim().length > 0) ? this.todasLasPrimerasMayusculas(itemFormated.nombres) : '';
        itemFormated.apellidos = (itemFormated.apellidos && itemFormated.apellidos.trim().length > 0) ? this.todasLasPrimerasMayusculas(itemFormated.apellidos) : '';
        pacientes.push(itemFormated);
      }

      const data = {
        pacientes,
        cirugias: this.cirugiaSeleccionadas.map((item) => {
          return { idCirugia: item.id };
        }),
        tiempo: this.duracion,
        precio: this.redondearAlCienMasProximo(this.precioTotal()),
        porcentajeDescuento: this.descuento,
        tipoAnestesia: this.anestesia == "general" ? 0 : 1,
        duracion: this.duracion,
        valor: this.redondearAlCienMasProximo(this.precioTotal()),
        poliza: this.polizaSeleccionada ? this.polizaSeleccionada.id : null,
        codigoCotizacion: "COT" + this.$moment().format("DDMMYYYYHHmmss"),
        aceptoPoliticas: this.aceptoPoliticas ? 1 : 0,
      };

      this.crearCotizacionDialog = false;
      this.cotizacionesService
        .crearCotizacion(data)
        .then((response) => {
          this.crearCotizacionDialog = false;
          this.$toast.add({
            severity: "success",
            summary: this.$t("messages.successful"),
            detail: this.$t("messages.quotationCreatedSuccessfully"),
            life: 3000,
          });
          this.id = response.data.data.id;
          this.descargarpdfconid(response.data.data.id);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    todasLasPrimerasMayusculas(cadena) {
      var words = cadena.toLowerCase().split(" ");
      for (var i = 0; i < words.length; i++) {
        if (words[i].length > 1) {
          words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
        }
      }
      var capitalizedSentence = words.join(" ");
      return capitalizedSentence;
    },
  },
  watch: {
    cirugiaSeleccionadas() {
      this.valor = 0;
      this.id = null;
    },
    anestesia() {
      this.cirugiaSeleccionada = null;
      this.cirugiaSeleccionadas = [];
      this.filtrarCirugias();
      this.id = null;
    },
    duracion() {
      this.valor = 0;
      this.id = null;
    },
  },
  computed: {
    validatePaciente() {
      if (this.item.tipoIdentificacion && this.item.identificacion && this.item.nombres && this.item.apellidos) {
        return this.item.tipoIdentificacion.trim() && this.item.identificacion.trim() && this.item.nombres.trim() && this.item.apellidos.trim();
      }
      return false
    },
    polizasNombreFormateado() {
      return this.polizas.map((item) => {
        item.nombre = item.nombre + " - " + this.formatNumber(item.valor) + " COP";
        return item;
      });
    },
    allItemsAreNull() {
      return (this.item.tipoIdentificacion == null || this.item.tipoIdentificacion.trim() == "") &&
        (this.item.identificacion == null || this.item.identificacion.trim() == "") &&
        (this.item.nombres == null || this.item.nombres.trim() == "") &&
        (this.item.apellidos == null || this.item.apellidos.trim() == "");
    },
    tiposDeIdentificacion(){
      return [
        { name: this.$t("messages.civilRegistration"), value: "RC" },
        { name: this.$t("messages.identityCard"), value: "TI" },
        { name: this.$t("messages.citizenshipCard"), value: "CC" },
        { name: this.$t("messages.foreignerIdentityCard"), value: "CE" },
        { name: this.$t("messages.passport"), value: "PA" }
      ]
    }
  }
};
</script>

<style scoped>
.containerFull {
  padding: 20px 300px;
}

.valor {
  font-size: 2rem;
  letter-spacing: 3px;
}

.p-autocomplete-multiple-container {
  width: 100%;
}

.incluyentes {
  font-size: 15px;
  text-align: justify;
}

.itemSelected:nth-of-type() {
  border: 5px solid red;
}

.itemSelected {
  display: flex;
  align-items: center;
}

.inputDuracion {
  width: 20%;
}

.autocompleteCirugias {
  width: 50%;
}

.boton-descarga {
  float: right;
}

li {
  font-size: 18px;
  margin-bottom: 14px;
}

p {
  font-size: 18px;
}

@media screen and (max-width: 1200px) {
  .containerFull {
    padding: 20px 40px;
  }

  .inputDuracion {
    width: 99%;
  }

  .autocompleteCirugias {
    width: 100%;
  }
}

@media screen and (max-width: 800px) {
  .boton-descarga {
    float: unset;
    margin-bottom: 30px;
  }

  .containerFull {
    padding: 10px 10px;
  }
}

@media print {
  .containerFull {
    padding: 0px;
  }

  .inputDuracion {
    width: 99%;
  }

  .autocompleteCirugias {
    width: 100%;
  }
}
</style>
